module.exports = __webpack_public_path__ + "static/img/年度最佳国产AI智能助手.1d44d749.png";